import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { PATHS } from '../../Config/Routing/paths'
import { authorization } from '../../Module/Auth/Auth'
import { addAuthParamsToCampaignBuilderUrl } from '../Country/Page/Pipeline/PipelineView/utils'
import { CONFIG } from '../../Config/config'
import { styles } from './UploadDesign.styles'

const useStyles = makeStyles(() => styles)

const UploadDesign = () => {
  const classes = useStyles()
  const history = useHistory()
  const user = authorization.getUser()
  const clientId = user.client.id
  const [isLoading, setIsLoading] = useState(true)
  const [iframeUrl, setIframeUrl] = useState('')
  const [isSaveEnabled, setIsSaveEnabled] = useState(false)

  useEffect(() => {
    if (clientId) {
      const url = addAuthParamsToCampaignBuilderUrl(
        `${CONFIG.SS_BASE_URL}/design-upload/${clientId}?countryCode=${
          user.countryCode
        }`,
        clientId,
      )
      setIframeUrl(url)
      setIsLoading(false)
    }
  }, [clientId])

  // Add postMessage listener to handle messages from DesignSelection.tsx
  useEffect(() => {
    const handleMessage = event => {
      // Verify the message is from the expected origin
      if (event.origin !== CONFIG.SS_BASE_URL) {
        return
      }

      const { type } = event.data
      switch (type) {
        case 'onDesignUploaded':
          // Enable save button when a design is selected
          setIsSaveEnabled(true)
          break
        default:
          break
      }
    }

    window.addEventListener('message', handleMessage)

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (!clientId) {
    return <div>Error: Client ID not found</div>
  }

  if (isLoading) {
    return (
      <main className={classes.loadingContainer}>
        <div className={classes.loadingContent}>
          <div className={classes.loadingText}>Loading upload page...</div>
        </div>
      </main>
    )
  }

  return (
    <main className={classes.mainContainer}>
      <header className={classes.header}>
        <div className={classes.backButtonContainer}>
          <div className={classes.backIconContainer}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9027e467a3654d80815291ebf67cf00c/5a1c5f84dbfd4a5cacb14867c018626d5ec3ca93?placeholderIfAbsent=true"
              alt=""
              className={classes.backIcon}
              onClick={() => {
                history.push(
                  `${PATHS.main.dashboard}${PATHS.dashboard.designManagement}`,
                )
              }}
            />
          </div>
        </div>
        <div className={classes.backText}>Back to design management page</div>
      </header>
      <div className={classes.title}>Now, upload your design</div>
      <div className={classes.contentContainer}>
        {iframeUrl && (
          <iframe
            title="Upload design"
            src={iframeUrl}
            className={classes.iframe}
            allow="clipboard-read; clipboard-write; *"
            onLoad={() => setIsLoading(false)}
          />
        )}
        <button
          onClick={() => {
            history.push(
              `${PATHS.main.dashboard}${PATHS.dashboard.designManagement}`,
            )
          }}
          disabled={!isSaveEnabled}
          className={`${classes.saveButton} ${
            isSaveEnabled
              ? classes.saveButtonEnabled
              : classes.saveButtonDisabled
          }`}
        >
          Save
        </button>
      </div>
    </main>
  )
}

export default UploadDesign
